module.exports = __webpack_public_path__ + "static/Logo_2-1b534634f107e2984a8a8614aaf69c57.png";